import { Sidebar } from "@xola/ui-kit";
import React from "react";
import { CustomMenuItems } from "./CustomMenuItems";
import { MenuItem } from "./MenuItem";
import { getPermissions } from "@/stores/globalStore";

export const ProductMenuItems = () => {
    const permissions = getPermissions();

    return (
        <>
            {permissions.canViewProductCatalog && (
                <MenuItem isSubMenuItem route="products/experiences" label="Experiences" />
            )}
            {permissions.canViewProductCatalog && permissions.canViewGiftOffers && (
                <MenuItem isSubMenuItem route="products/giftOffers" label="Gifts" />
            )}
            {permissions.canViewMerchandise && (
                <MenuItem isSubMenuItem route="products/merchandise" label="Merchandise" />
            )}

            {permissions.canViewProductCatalog && permissions.canViewPackages && (
                <MenuItem isSubMenuItem route="products/packages" label="Packages" />
            )}
            {permissions.canViewProductCatalog && permissions.canViewMemberships && (
                <MenuItem isSubMenuItem route="products/memberships" label="Memberships" />
            )}
            {permissions.canViewProductCatalog && permissions.canViewPartnerPackages && (
                <MenuItem isSubMenuItem route="products/partnerPackages" label="Partner Packages" />
            )}
            <Sidebar.Separator />
            {permissions.canViewGlobalSettings && (
                <MenuItem isSubMenuItem route="products/globalSettings" label="Global Settings" />
            )}
            {permissions.canViewMerchandise && <MenuItem isSubMenuItem route="products/inventory" label="Inventory" />}
            <CustomMenuItems route="products" />
        </>
    );
};
